<div class="body ui container" fxLayout="column">
  <!-- <div class="ui divider" appMargin marginY="3"></div> -->

  <div [suiCollapse]="!advancedSearchVisible" appMargin marginY="3">
    <div class="ui segment">
      <app-search-filter-null
        [headers]="headers"
        searchName="Invoice"
        (onCancel)="advancedSearchVisible = !advancedSearchVisible"
        (submitSearch)="advancedSearch($event)"
      ></app-search-filter-null>
    </div>
  </div>

  <!-- <div class="ui segment" style="border-radius: 4px;" appMargin marginT="0"> -->
  <app-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
  ></app-search-filter>
  <!-- </div> -->

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="15px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <!-- <div fxFlex="5%">
        <sui-checkbox> </sui-checkbox>
      </div> -->
      <div fxFlex="15%">{{ isInvoiced ? "INVOICE NO." : "RRR" }}</div>
      <div *ngIf="!isInvoiced" fxFlex="15%">DESCRIPTION</div>
      <div fxFlex="15%">SERVICE TYPE</div>
      <div fxFlex="20%">INVOICE AMOUNT</div>
      <div fxFlex="grow">STATUS</div>
      <div fxFlex="10%">DATE CREATED</div>
      <div fxFlex="10%">GATEWAY TRANSACTION DATE</div>
      <div fxFlex="10%"></div>
    </div>

    <!-- <app-payment-row
		[payment]="s"
		*ngFor="let s of invoices"
        (onView)="viewDepartment($event)"></app-payment-row>
         -->
    <div
      *ngFor="let payment of invoices"
      class="ui attached segment"
      appMargin
      marginT="5"
    >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <!-- <div fxFlex="5%">
          <sui-checkbox> </sui-checkbox>
        </div> -->
        <div fxFlex="15%">
          {{ payment?.invoiceNumber || payment?.gatewayTransactionRefId }}
        </div>
        <div *ngIf="!isInvoiced" fxFlex="15%">{{ payment?.description }}</div>
        <div fxFlex="15%">{{ payment?.categoryName }}</div>
        <div fxFlex="20%">
          {{ payment?.currencyCode }}
          {{ payment?.totalAmount | number: ".2-2" }}
        </div>
        <div fxFlex="grow">
          <span
            class="ui yellow circular label"
            [style]="{ margin: 0 }"
            style="word-break: break-all"
            [ngClass]="{ green: payment?.status == 'CONFIRMED' }"
            >{{ payment?.status }}</span
          >
        </div>
        <div fxFlex="10%">{{ payment?.dateCreated | date }}</div>
        <div fxFlex="10%">{{ payment?.dateCreated | date }}</div>
        <div fxFlex="10%" class="text-right">
          <button
            suiPopup
            popupText="View Payment Detail"
            popupInverted
            popupPlacement="button"
            class="ui circular tiny button"
            (click)="view(payment)"
          >
            <svg
              width="12"
              height="12"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="info_30px">
                <path
                  id="icon/action/info_30px"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V9H13V7H11ZM11 11V17H13V11H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z"
                  fill="#86879D"
                />
              </g>
            </svg>
          </button>
          <!-- <button
            *ngIf="payment.documentPath"
            suiPopup
            popupText="Download Payment Receipt"
            popupInverted
            popupPlacement="button"
            class="ui circular tiny button"
            (click)="download(payment.documentPath)"
          >
            <i class="download icon"></i>
          </button> -->
          <a
            *ngIf="payment.documentPath"
            suiPopup
            popupText="View Payment Receipt"
            popupInverted
            popupPlacement="button"
            class="ui circular tiny button"
            href="{{ financeBaseUrl }}/public/media/?media={{
              payment.documentPath
            }}"
            target="_blank"
            ><i class="eye icon"></i
          ></a>
        </div>
      </div>
    </div>
    <app-no-record-found
      *ngIf="invoices && invoices.length < 1"
    ></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui labeled button">
            <div class="ui tiny icon button" (click)="getPage(1)">
              <i class="refresh icon"></i>
            </div>
            <a class="ui basic label"> {{ totalItems }} Record(s) </a>
          </div>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="mini"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
